import { take, call, put } from 'redux-saga/effects';
import { sectors as actionTypes } from '$constants/action-types';
import { fetchAllSuccess } from '$actions/sectors';
import axios from 'axios';

const fetchAll = () => axios.get(`/sectors`, { params: { language: 'en' } });

function* watchFetchAll() {
  while(true) {
    yield take(actionTypes.FETCH_ALL);
    const { data } = yield call(fetchAll);
    yield put(fetchAllSuccess(data.data));
  }
}

export const watchers = [
  watchFetchAll
];



// WEBPACK FOOTER //
// ./src/sagas/sectors.js